import ContractIcon from './images/ic-contrato-faturacao.svg'

export default [
  {
    name: 'Contrato e Faturação',
    icon: ContractIcon,
    size: 12,
    type: 'multifull',

    dependsOn: 'offer_type',

    filters: [
      {
        name: 'Fidelização',
        fieldName: 'no_contract_duration',
        values: [
          { label: 'Qualquer', value: 'any' },
          { label: 'Sem Fidelização', value: true },
          { label: 'Com Fidelização', value: 'false' },
        ],
      },
      {
        name: 'Faturação',
        fieldName: 'billing',
        checkboxed: true,
        removedSelectOnSelected: ['any'],
        excludeAllExceptOnSelect: ['any'],
        values: [
          { label: 'Qualquer', value: 'any' },
          { label: 'Débito Direto (DD)', value: 'dd' },
          { label: 'MB / CTT / PayShop', value: 'mb' },
          { label: 'Fatura eletrónica (FE)', value: 'fe' },
          { label: 'Fatura em papel', value: 'fp' },
          { label: 'Contratação eletrónica (CE)', value: 'ce' },
        ],
      },
      {
        name: 'Mais filtros',
        fieldName: 'extra',
        checkboxed: true,
        values: [
          { label: 'Energia Verde', value: 'ge' },
          { label: 'Sem Reembolsos', value: 'hr' },
          { label: 'Sem serviços adicionais (€)', value: 'as' },
          { label: 'Tarifa Regulada', value: 'rg' },
          { label: 'Mobilidade Eléctrica', value: 'me' },
        ],
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/containers/Filters/data.js